<div class="pmt" >
  <div class="pmt-title">
    {{'CONTRACTS.CARD.STEPS.general_credit_letter' |translate}}
  </div>
  <div class="pmt-summary contract-grid-first-border" >
      <img class="pmt-summary-icon"  src="../../../../../assets/images/contract/payment-status/shield-check-fill.svg" >
      <div class="pmt-summary-amount">
        <div class="pmt-summary-amount-title" >{{'CONTRACTS.CARD.PAYMENT.CREDIT_LETTER_FULL'|translate}}</div>
        <div class="pmt-summary-amount-data" >{{paymentTotal  | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}</div>
      </div>
  </div>
  <div class="pmt-details contract-grid-first-border" *ngIf="paymentDetails">
    <div class="pmt-details-item" *ngFor="let item of paymentDetails"> 
      <span class="pmt-details-item-key">{{'FINANCE.PAYMENT.'+item.key|translate}}</span>
      <span [class]="'pmt-details-item-value ' + (item.key==='status'?  item.value : '' )" >{{item.value}}</span>
    </div>
  </div>
  <div class="pmt-button-block">
    <button (click)="cancelAction()" class="button-icon size-xxl secondary-button ">
      <mat-icon svgIcon="close-fill"></mat-icon>
      {{ 'MODALS.BUTTONS.CLOSE'|translate }}
    </button>
  </div>
</div>